'use client';

import React, { useEffect } from 'react';
import { Typography } from '@/components/atoms/Typography/Typography';
import { CustomLink } from '@/components/atoms/CustomLink/CustomLink';
import { Logo } from '@/components/atoms/Logo/Logo';
import { ComponentContainer } from '@/components/atoms/ComponentContainer/ComponentContainer';
import { Button } from '@/components/atoms/Button/Button';
import { toggleModal } from '@/utils/generic';
import { events } from '@/utils/events';
import { useTranslations } from 'next-intl';
import * as Styled from './Footer.styled';
import { usePageStore } from '@/store/usePageStore';
import { getCookie } from '@/utils/cookies';
import { emailEncoded, emailEstudioDecoded } from '@/utils/constants';

export const Footer: React.FC = () => {
  const t = useTranslations('footer');
  const stateSelector = usePageStore;
  const isUserLogged = stateSelector((s) => s.isUserLogged);
  const setIsUserLogged = stateSelector((s) => s.setIsUserLogged);
  
  const addressFirst = {
    en: "Nàpols 193, Bajos int<br /> 08013 Barcelona (Spain)<br /><br data-mobile/> +34 93 318 75 13",
    es: "Nàpols 193, Bajos int<br /> 08013 Barcelona (Spain)<br /><br data-mobile/> +34 93 318 75 13",
  };
  const addressSecond = {
    en: "Cuesta del Rosario 8, Portal 1, 1G<br /> 41004 Sevilla (España)<br /><br data-mobile/> +34 854 55 82 57",
    es: "Cuesta del Rosario 8, Portal 1, 1G<br /> 41004 Sevilla (España)<br /><br data-mobile/> +34 854 55 82 57",
  };

  const logInText = t('logInText');
  const logOutText = t('logOutText');
  const social = t.raw('social') as { text: string; href: string }[];
  const privacyPolicy = t.raw('privacyPolicy') as {
    text: string;
    slug: string;
  };
  const legalNote = t.raw('legalNote') as {
    text: string;
    slug: string;
  };

  useEffect(() => {
    if (!window) return;
    
    const cookieBgUser = decodeURIComponent(getCookie('bg_user') || '');
    if (cookieBgUser) {
      const cookieData = JSON.parse(cookieBgUser);
      setIsUserLogged(cookieData?.email ? true : false);
    } else {
      setIsUserLogged(false);
    }
  }, [setIsUserLogged]);

  return (
    <footer>
      <ComponentContainer 
        width={'main'} 
        marginBottom={'none'}
        marginBottomOnMobile='none'
      >
        <Styled.FooterContent>
          <Logo />
          <Typography
            text={addressFirst}
            color="tertiary"
            hideDesktopBrInMobile={false}
          />
          <Typography
            text={addressSecond}
            color="tertiary"
            hideDesktopBrInMobile={false}
          />
          <CustomLink
            href={`#`}
            text={emailEncoded}
            className="email"
            isEmailEncoded={true}
            emailDecoded={emailEstudioDecoded}
            color="tertiary"
            hoverColor="primary"
          />    
          <Styled.SocialLinks>
            {social &&
              social.length > 0 &&
              social.map((item, index) => (
                <li key={`item-footer-${index}`}>
                  <CustomLink
                    href={item.href}
                    text={item.text}
                    color="tertiary"
                    hoverColor="primary"
                    target='_blank'
                    prefetch={false}
                  />
                </li>
              ))}
          </Styled.SocialLinks>
          <Button
            text={isUserLogged ? logOutText : logInText}
            callbackOnClick={() => toggleModal(events.toggleLoginModal)}
            color="tertiary"
          />
          <Styled.SocialLinks>
            <li>
              <CustomLink
                href={privacyPolicy.slug}
                text={privacyPolicy.text}
                color="tertiary"
              />
            </li>
            <li>
              <CustomLink
                href={legalNote.slug}
                text={legalNote.text}
                color="tertiary"
              />
            </li>
          </Styled.SocialLinks>
        </Styled.FooterContent>
      </ComponentContainer>
    </footer>
  );
};
